<template>
  <v-list
    rounded
    class="app-navigation custom-scrollbar title-text-2"
    style="overflow-x: hidden;height: 100%;width:auto"
    :class="{
      mini: minimified,
      'app-sticky': sticky
    }"
  >
    <v-list-item-group
      class="title-text-2 semibold"
      color="primary"
      :class="resizeBtn"
    >
      <v-list-item class="develop-notify col-12" v-if="config.isDevelop">
        <h5>ENTORNO DE DESARROLLO</h5>
      </v-list-item>
      <v-expand-x-transition v-if="!maintance">
        <v-list-item>
          <v-list-item-content>
            <PublicationLauncher :icon="minimified"/>
          </v-list-item-content>
        </v-list-item>
      </v-expand-x-transition>
      <v-list-item
        class="navigation-item justify-end"
        style="height: 40px !important;"
        v-for="item in availableSections"
        :key="item.title"
        :to="item.link"
        :href="item.href"
        :target="item.redirect ? '_blank' : ''"
        @click="hideSettings()"
      >
        <v-list-item-icon>
          <v-icon :color="item.color">{{ item.icon }}</v-icon>
          <span v-if="unreadMessages && isIconMessage(item)" class="notification-unread-message">{{
              countUnreadMessages
            }}</span>
        </v-list-item-icon>
        <v-list-item-content v-if="!minimified">
          <v-list-item-title>{{
              $t(`application.menu.${item.title}`)
            }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
    <div class="flex-grow-1"></div>
    <v-list-item-group color="primary" v-if="authenticated">
      <v-list-item
        class="navigation-item"
        :class="{ 'justify-center': minimified }"
      >
        <UserAvatar :mini="minimified" :user="currentUser">
          <div slot="name" class="title-text-3 bold greyish-text">
            {{ currentUser.displayName }}
          </div>
          <div slot="username" class="regular-text light-text">
            {{ `@${currentUser.username}` }}
          </div>
        </UserAvatar>
      </v-list-item>
      <v-list-item
        class="navigation-item justify-end"
        :to="{ name: 'settings' }"
      >
        <v-list-item-icon>
          <v-icon>settings</v-icon>
        </v-list-item-icon>
        <v-list-item-content v-if="!minimified">
          <div class="regular-text light-text">
            {{ $t('application.menu.settings') }}
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import {mapState} from 'vuex'
import {ChatActions} from '@/store'
import PublicationLauncher from '@/components/custom/PublicationLauncher'
import UserAvatar from '@/components/users/UserAvatar'
import config from '@/project'

export default {
  name: 'AppNavigation',
  components: {PublicationLauncher, UserAvatar},
  props: {sticky: Boolean, maintance: Boolean},
  data() {
    return {
      config
    }
  },
  computed: {
    ...mapState('application', [
      'isMobile',
      'isLargeScreen',
      'hasMessages',
      'countUnreadMessages'
    ]),
    ...mapState('profile', [
      'currentUser',
      'isInfluencer',
      'isFollower',
      'isAdmin',
      'isController',
      'isAccountManager',
      'isAgent'
    ]),
    ...mapState('session', ['authenticated']),
    resizeBtn() {
      return {
        'resize-btn': this.$i18n.locale === 'de'
      }
    },
    unreadMessages() {
      return this.countUnreadMessages !== ''
    },
    availableSections() {
      const items = this.isMobile
        ? [
          {
            icon: 'home',
            title: 'home',
            link: {name: 'home'},
            except: 'admin'
          },
          ...this.allSections()
        ]
        : this.allSections()
      return items
        .filter(item => this.isAvailable(item))
        .map(item => {
          if (item.title === 'messages') {
            item.icon = 'chat'
            item.color = this.hasMessages ? 'primary' : ''
          }
          return item
        })
    },

    minimified() {
      return !this.isMobile && !this.isLargeScreen
    },

    isDevelopfunction() {
      return this.isAdmin
    }
  },

  methods: {
    isAvailable(item) {
      if (item.show === false) {
        return false
      }
      if (item.only) {
        return [item.only].flat().includes(this.currentUser.role)
      }
      if (item.except) {
        return ![item.except].flat().includes(this.currentUser.role)
      }
      return true
    },
    allSections() {
      const redirect = config.payments.darkfans_redirect && this.isFollower
      if (!this.authenticated) {
        return [
          {
            icon: 'stars',
            title: 'influencers',
            link: {name: 'stars_discover'},
            show: true
          },
          {
            icon: 'theaters',
            title: 'stories',
            href: `${config.domains.baseUrl}/campaigns/tiktak/index.html`,
            redirect: true,
            show: true
          },
          {
            icon: 'radio_button_checked',
            title: 'lives',
            link: {name: 'conferences'},
            show: true
          },
          {
            icon: 'video_library',
            title: 'videotube',
            link: {name: 'medialib'},
            show: true
          },
          {
            icon: 'shopping_basket',
            title: 'market',
            link: {name: 'marketplace'},
            show: true
          }
        ]
      } else {
        return [
          {
            icon: 'stars',
            title: 'influencers',
            link: {name: 'stars'},
            except: ['admin', 'account_manager']
          },
          {
            icon: 'theaters',
            title: 'stories',
            href: `${config.domains.baseUrl}/campaigns/tiktak/index.html`,
            redirect: true
          },
          {
            icon: 'bookmarks',
            title: 'favorites',
            link: {name: 'favorites'},
            except: ['admin', 'account_manager']
          },
          {
            icon: 'radio_button_checked',
            title: 'lives',
            link: {name: 'conferences'},
            except: 'account_manager'
          },
          {
            icon: 'video_library',
            title: 'videotube',
            link: {name: 'medialib'},
            except: ['admin', 'account_manager']
          },
          {
            icon: 'shopping_basket',
            title: 'market',
            link: {name: 'marketplace'},
            except: ['admin', 'account_manager'],
            show: this.currentUser.username === 'follower'
          },
          {
            icon: 'people',
            title: 'users',
            link: {name: 'controller_users'},
            only: ['controller']
          },
          {
            icon: 'chat',
            title: 'messages',
            redirect: redirect,
            href: redirect ? `https://darkfans.com/messages?oa=${this.currentUser.sessionToken}&utm_source=${config.project}` : undefined,
            link: redirect ? undefined : {name: 'messages'},
            except: ['admin', 'account_manager']
          },
          {
            icon: 'show_chart',
            title: 'statistics',
            link: {name: 'statistics'},
            only: 'influencer'
          },
          {
            icon: 'supervised_user_circle',
            title: 'agents',
            link: {name: 'partners'},
            show: !!this.isAgent
          },
          {
            icon: 'record_voice_over',
            title: 'referrals',
            link: {name: 'referrals'},
            only: 'influencer'
          },
          {
            icon: 'people',
            title: 'users',
            link: {name: 'admin_users'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'supervised_user_circle',
            title: 'agents',
            link: {name: 'admin_agents'},
            only: 'admin'
          },
          {
            icon: 'class',
            title: 'categories',
            link: {name: 'admin_categories'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'approval',
            title: 'post_promo',
            link: {name: 'post_promo'},
            show: this.currentUser.username === 'jgar' || this.isAdmin
          },
          {
            icon: 'approval',
            title: 'post_promo',
            link: {name: 'post_promo_controller'},
            show: this.isController
          },
          {
            icon: 'chat',
            title: 'messages',
            link: {name: 'admin_messages'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'photo_filter',
            title: 'resources',
            link: {name: 'resources'},
            only: 'influencer',
            show: config.enable_resources
          },
          {
            icon: 'live_help',
            title: 'tutorial',
            link: {name: 'tutorials'},
            only: 'influencer'
          },
          {
            icon: 'flag',
            title: 'complaints',
            link: {name: 'admin_complaints'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'flag',
            title: 'complaints',
            link: {name: 'complaints'},
            only: 'controller'
          },
          {
            icon: 'how_to_reg',
            title: 'admin',
            link: {name: 'admin_service'},
            only: 'admin'
          },
          {
            icon: 'euro',
            title: 'bonus',
            link: {name: 'bonuses'},
            only: 'admin'
          },
          {
            icon: 'beenhere',
            title: 'validation',
            link: {name: 'admin_validation'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'beenhere',
            title: 'validation',
            link: {name: 'controller_validation'},
            only: ['controller']
          },
          {
            icon: 'attach_money',
            title: 'billing',
            link: {name: 'admin_billing'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'group_add',
            title: 'addFollowers',
            link: {name: 'admin_addFollowers'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'dynamic_feed',
            title: 'xsale',
            link: {name: 'admin_delegateMessages'},
            only: ['admin', 'account_manager']
          },
          {
            icon: 'settings',
            title: 'development',
            link: {name: 'admin_development'},
            show: this.isDevelopfunction
          }
        ]
      }
    },
    hideSettings() {
      this.$store.dispatch(ChatActions.SelectChat, null)
      this.$store.dispatch(ChatActions.ShowChatSetting, false)
      this.$store.dispatch(ChatActions.ShowChatNew, false)
      this.$store.dispatch(ChatActions.ShowSetting, false)
      this.$store.dispatch(ChatActions.ShowVideoChat, false)
      this.$store.dispatch(ChatActions.ShowCarousel, false)
    },
    isIconMessage(item) {
      return item.icon === 'chat'
    }
  }
}
</script>
<style lang="scss" scoped>
.mini {
  max-width: 100%;
}

.resize-btn {
  min-width: fit-content;
}

.notification-unread-message {
  margin-top: -6px;
  margin-left: -7px;
}

.develop-notify {
  background-color: #DA15FCA3;
  width: 100%;
  text-align: center;
}
</style>
